// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3PM7M","actionsCol":"EnrolledClinics_actionsCol__3tAoC"};